
export const HOST_URL = "https://myshipments.tgfworld.com/transysapi/"
// export const HOST_URL = "https://dev.sflhub.com/transysapi/"
export const version_no = "1.3.7"